import { TenantConfig } from './types';

export const collinsonConfig: TenantConfig = {
  tenantName: 'Collinson',
  iconUrl:
    'https://assets.poshvine.com/merchants/tfs/lounges/admin-portal/collinson-logo.svg',
  faviconUrl:
    'https://assets.poshvine.com/merchants/tfs/lounges/admin-portal/collinson-favicon.webp',
  supportEmail: 'support@razorpay.com',
};
